import AppLauncherList from '@components/AppLauncherList/AppLauncherList';
import { textFieldPostalCode } from '@components/TextField/TextField';
import { verifyRecaptcha } from '@js/utils/Recaptcha';

textFieldPostalCode({ hideCity: true });
AppLauncherList();

const initRecaptcha = () => {
  const form = document.querySelector('#form-register');

  form.addEventListener('submit', async (event) => {
    event.preventDefault();

    try {
      await verifyRecaptcha(form);
    } catch (error) {
      const alert = document.querySelector('.js-alertRegister');

      if (!alert) return;

      alert.classList.remove('hidden');
      alert.innerHTML = error.message;

      return;
    }

    form.submit();
  });
};

initRecaptcha();

